import { render } from "./ParentDetails.vue?vue&type=template&id=3f1f03a6&scoped=true"
import script from "./ParentDetails.vue?vue&type=script&lang=js"
export * from "./ParentDetails.vue?vue&type=script&lang=js"

import "./ParentDetails.vue?vue&type=style&index=0&id=3f1f03a6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1f03a6"]])

export default __exports__